import { render, staticRenderFns } from "./MessageErrorHandler.vue?vue&type=template&id=0fff6b55&scoped=true&"
import script from "./MessageErrorHandler.vue?vue&type=script&lang=js&"
export * from "./MessageErrorHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff6b55",
  null
  
)

export default component.exports